import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import "angular-cookies";
import auth from "../../services/auth.js";
import env from "../../services/env.js";
import security from "../../services/security.js";

class SignonController {
  constructor(
    $http,
    $localStorage,
    $state,
    $location,
    $window,
    SignupValidator,
    $stateParams,
    ProfileService,
    AuthService,
    EnvService,
    SignonService,
    $timeout,
    SecurityService,
    $rootScope,
    $scope,
    TrackingService,
    $cookies,
    $social,
    validation
  ) {
    this.name = "signon";
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$env = EnvService;
    this.$profile = ProfileService;
    this.$window = $window;
    this.$location = $location;
    this.$signon = SignonService;
    this.$timeout = $timeout;
    this.$security = SecurityService;
    this.$rootScope = $rootScope;
    this.$social = $social;
    this.$tracking = TrackingService;
    this.payload = {};
    this.$scope = $scope;
    this.$cookies = $cookies;
    this.$stateParams = $stateParams;
    this.validator = SignupValidator;
    this.validation = {};
    this.currentUser = this.$auth.getUserData();
    this.canValidate = false;
    this.$timeout(() => (this.canValidate = true), 1000);
    this.uiView = {
      accountType: {
        business: null,
        jobbler: null,
      },
      companyName: null,
      step: 1,
      email: null,
    };

    this.determineUserType();

    window.fbOnLogin = () => this.fbSuccessfulLogin();

    window.document.addEventListener("AppleIDSignInOnSuccess", (data) => {
      this.handleAppleSignin(data.detail);
    });

    window.document.addEventListener("AppleIDSignInOnFailure", (error) => {});

    var FB = window.FB;

    if (FB) {
      FB.init({
        appId: "1097626717272010",
        autoLogAppEvents: true,
        xfbml: true,
        version: "v10.0",
      });

      FB.Event.subscribe("xfbml.render", this.faceBookRendered());
    }

    var _this = this;

    _this.SetSignOnPage = _this.$rootScope.$on("SetSignOnPage", function (event, params) {
      _this.$timeout(function () {
        if (params === "jobbler") {
          _this.uiView.accountType.business = false;
          _this.uiView.accountType.jobbler = true;
        } else {
          _this.uiView.accountType.business = true;
          _this.uiView.accountType.jobbler = false;
        }
      });
    });

    _this.$scope.$on("$destroy", _this.SetSignOnPage);

    this.canValidate = false;
    this.$timeout(() => (this.canValidate = true), 1000);

    this.$timeout(() => {
      const target = document.querySelector("div.sms-code-container");
      target.addEventListener("paste", (event) => {
        let copyCode = (event.clipboardData || window.clipboardData).getData("text");
        copyCode = copyCode.trim();
        if (copyCode.length === 6) {
          this.smsCode_1 = copyCode.charAt(0);
          this.smsCode_2 = copyCode.charAt(1);
          this.smsCode_3 = copyCode.charAt(2);
          this.smsCode_4 = copyCode.charAt(3);
          this.smsCode_5 = copyCode.charAt(4);
          this.smsCode_6 = copyCode.charAt(5);
          for (let i = 0; i <= 5; i++) {
            document.getElementById("sms-code-" + (i + 1)).value = copyCode.charAt(i);
          }
          this.codeEntered(6);
        }
        event.preventDefault();
      });
    }, 1000);
  }

  signin() {
    let urlParam = this.$location.$$search.accountType;
    let action = this.$location.$$search.action;

    if (urlParam === "business") {
      this.$location.url("/signup/company");
    } else {
      if (action === "signin") {
        this.$location.url("/signin");
      } else {
        this.$location.url("/signup/jobbler");
      }
    }
  }

  googleSignIn() {
    let data = {};
    let dataForLogin = {};

    var _this = this;
  }

  renderGoogle() {
    let data = {};
    let dataForLogin = {};

    var _this = this;

    this.$timeout(() => {
      gapi.load("auth2", function () {
        // Loads the auth2 component of gapi

        gapi.auth2
          .init({
            // initialize the auth2 using your credentials
            client_id: _this.$env.EnvironmentConfig.thirdPartySignon.google,
          })
          .then(function onInit() {
            // on complete of init

            gapi.signin2.render("g-signin2", {
              scope: "profile email",
              width: 328,
              height: 40,
              longtitle: true,
              theme: "dark",

              onsuccess: function (googleUser) {
                // This executes when a user successfully authorizes you to their data by clicking the button and selecting their account.

                let profile = googleUser.getBasicProfile();
                let id_token = null;

                console.log("Google profile:", profile);

                try {
                  console.log("Google profile ID: " + profile.getId());
                  let authResponse = googleUser.getAuthResponse();
                  console.log("Google authResponse:", authResponse);
                  id_token = authResponse.id_token;
                  console.log("Google authResponse id_token:", id_token);
                } catch (e) {
                  console.error("Google authResponse error:", e);
                }

                dataForLogin.connectedAccountType = "GOOGLE";
                data.connectedAccountType = "GOOGLE";
                data.username = profile.getEmail();
                data.firstName = profile.getGivenName();
                data.lastName = profile.getFamilyName();

                if (googleUser.tc) {
                  dataForLogin.connectedAccountToken = googleUser.tc.id_token;
                  data.connectedAccountToken = googleUser.tc.id_token;
                } else if (googleUser.uc) {
                  dataForLogin.connectedAccountToken = googleUser.uc.id_token;
                  data.connectedAccountToken = googleUser.uc.id_token;
                } else if (googleUser.qc) {
                  dataForLogin.connectedAccountToken = googleUser.qc.id_token;
                  data.connectedAccountToken = googleUser.qc.id_token;
                }

                if (id_token) {
                  dataForLogin.connectedAccountToken = id_token;
                  data.connectedAccountToken = id_token;
                }

                if (_this.uiView.accountType.business === true) {
                  let company = {};
                  company.name = _this.uiView.companyName;
                  company.defaultPlan = 31;
                  data.company = company;
                }

                console.log("Data:", data);
                console.log("dataForLogin:", dataForLogin);

                _this.login(data, dataForLogin);
              },
            });
          });
      });
    }, 1000);
  }

  setValidation({field, valid, message}) {
    if (this.canValidate)
      this.$timeout(() => {
        this.validation[field] = {
          valid,
          style: {borderColor: valid ? "green" : "red"},
          message,
        };
      });
  }

  register(data, dataForLogin, needEmailConfirmation) {
    var _this = this;

    let handleAppleScreen = false;

    if (_this.uiView.accountType.business === true) {
      console.log("check name");
      console.dir(data);
      if (data.company.name === null) {
        _this.setCompanyPage(data, dataForLogin, true);
        return;
      }
    }

    if (needEmailConfirmation === true) {
      _this.confirmEmail(data, dataForLogin, needEmailConfirmation);
      return;
    }

    if (needEmailConfirmation === "apple") {
      handleAppleScreen = true;
      dataForLogin.handleAppleScreen = handleAppleScreen;
      dataForLogin.appleUsername = data.username;
    }

    _this.setLoader();

    _this.$signon.register(data, dataForLogin).then(
      function (response) {
        if (response.data.message.indexOf("Duplicate entry") > -1) {
          _this.sendUserToSignIn(data, dataForLogin);
        } else if (response.data.message.indexOf("The email provided is already connected") > -1) {
          _this.uiView.step = 1;
          _this.loadSignOnButtons(response.data.message);
        } else if (response.data.message === "The registration email was successfully sent") {
          _this.$timeout(function () {
            _this.login(data, dataForLogin);
          }, 500);
        } else {
        }

        _this.unSetLoader();
        _this.sendingConfirmaionEmail = false;
      },
      function (error) {
        console.log("error");
        console.dir(error);
      }
    );
  }

  login(data, dataForLogin) {
    console.log("login");
    console.dir(data);
    console.dir(dataForLogin);

    var _this = this;

    _this.setLoader();

    _this.$signon.login(data, dataForLogin).then(
      function (response) {
        console.log("what is the response");
        console.dir(response);
        console.log("after login dataForLogin");
        console.dir(dataForLogin);
        _this.unSetLoader();

        if (response.data.access_token) {
          _this.sendUser(response, dataForLogin);
        }
      },
      function (error) {
        console.log("error");
        console.dir(error);
        _this.unSetLoader();
        if (error.status === 401) {
          _this.register(data, dataForLogin, true);
        }
      }
    );
  }

  sendUser(response, dataForLogin) {
    let user = {};

    if (response.data.company) {
      if (response.data.status == "error" || !response.data.company) {
        console.log("what is the error");
        console.dir(response);
        _this.result.status = "error";
        _this.result.message = "Login failed. Please check your credentials and try again.";
        return;
      }

      //this.$tracking.reportUserLogin(data.data);
      response.data.companyId = response.data.company.id;
      user = response.data;
      this.$localStorage.logged_user = response.data;
      this.currentUser = response.data;
      this.$stateParams.t = user.access_token;
      this.$rootScope.jobbleTypes = this.$env.EnvironmentConfig.jobble_types;
      this.$auth.handlePaymentInfos(user, this.$stateParams, true);
      this.$state.go("postashiftwalkthrough");
      //this.uiView.step = 2;
    } else {
      user = response.data;
      this.$localStorage.logged_user = response.data;
      this.currentUser = response.data;
      this.removeBodyClass();
      //this.fbTrackLogin(u);
      this.$rootScope.jobbleTypes = this.$env.EnvironmentConfig.jobble_types;
      //this.currentUser.homeContactInfo = {};
      console.log("this is the user at this point");
      console.dir(this.currentUser);
      console.dir(_.isEmpty(this.currentUser.homeContactInfo));
      if (dataForLogin.handleAppleScreen === true) {
        alert(
          "Account created using " +
            dataForLogin.appleUsername +
            ". If you would like Jobble to send important messages to a different email address you can change it in your profile."
        );
      }

      user.type = dataForLogin.connectedAccountType;
      this.$tracking.reportJobblerSignUpThirdParty(user);

      if (_.isEmpty(this.currentUser.homeContactInfo) === true) {
        this.uiView.step = 2;
      } else if (this.currentUser.isVerified !== true) {
        this.uiView.step = 5;
        //this.$state.go('jobs');
      } else {
        this.$state.go("jobs");
      }
    }
  }

  getMostRecentUser() {
    return new Promise((resolve, reject) => {
      resolve(this.$auth.getUserData());
    });
  }

  saveUserNumber() {
    //let num = this.uiView.userNumber;
    //this.currentUser.homeContactInfo.phoneMobile = num;
    if (this.savingUserNumber === true) {
      return;
    }

    this.savingUserNumber = true;
    this.setLoader();
    //this.$profile.saveUser(this.currentUser)
    this.$profile
      .saveUser(this.currentUser)
      .then((response) => {
        console.log("what is the response after saving...");
        console.dir(response);
        this.$auth.refreshCurrentUser().then((user) => {
          this.getMostRecentUser().then((user) => {
            this.$timeout(() => {
              this.currentUser = user || this.currentUser;
              this.unSetLoader();
              this.savingUserNumber = false;
              this.sendSMSCode();
              console.log("what is the current user now");
              console.dir(this.currentUser);
            });
          });
        });
      })
      .catch((err) => {
        this.unSetLoader();
        this.savingUserNumber = false;
        this.$auth.refreshCurrentUser();
        console.error(err);
      });
  }

  sendSMSCode() {
    this.setLoader();

    this.$profile
      .sendSMSCode()
      .then((response) => {
        console.log("SMS Code Response");
        console.dir(response);
        this.unSetLoader();
        this.uiView.step = 3;
        //this.canUserApplyToShiftBasedJobs(true);
      })
      .catch((err) => {
        console.error("SMS Code Error", err);
        this.unSetLoader();
      });
  }

  codeEntered(num) {
    if (num <= 5 && this["smsCode_" + num]) {
      const el = document.getElementById("sms-code-" + (num + 1));
      el.focus();
      el.select();
    }

    let code = "" + this.smsCode_1 + this.smsCode_2 + this.smsCode_3 + this.smsCode_4 + this.smsCode_5 + this.smsCode_6;

    if (code.length === 6) {
      console.log("send request");
      this.validateSMSCode();
    }
  }

  validateSMSCode() {
    const code = "" + this.smsCode_1 + this.smsCode_2 + this.smsCode_3 + this.smsCode_4 + this.smsCode_5 + this.smsCode_6;

    this.setLoader();

    this.$profile
      .validateSMSCode(code)
      .then((response) => {
        this.$timeout(() => {
          this.smsVerified = true;
          this.sendAppLink();
          //this.$tracking.reportSMSVerified("job board", this.currentUser.email);
          this.$tracking.reportSMSVerified("third party - standard", this.currentUser.email);
          this.unSetLoader();
        });
      })
      .catch((err) => {
        console.error("SMS Validation error", err);
        this.$timeout(() => {
          this.smsVerificationError = true;
          this.smsVerificationErrorText = "Code invalid or expired";
          this.unSetLoader();
        }, 1000);
      });
  }

  backToPhoneVerification() {
    this.uiView.step = 2;
  }

  sendAppLink() {
    return new Promise((resolve) => {
      let req = {
        method: "POST",
        data: {
          body: "You are a Jobbler now! download the app to enhance your Jobble experience! Download: https://link.jobble.com/download-app",
        },
        url: this.$env.getAPIEndPoint() + "jbl/v1/sms",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
        },
      };

      this.$http(req)
        .then((response) => {
          console.log("SMS Response", response);
          resolve();
          this.unSetLoader();
          this.checkUsersVerificationStatus();
        })
        .catch((err) => {
          console.error("SMS Error", err);
          this.unSetLoader();
          this.checkUsersVerificationStatus();
          resolve();
        });
    });
  }

  checkUsersVerificationStatus() {
    console.log("checkUsersVerificationStatus");
    console.dir(this.currentUser);

    if (this.currentUser.isVerified === true) {
      this.$state.go("jobs");
    } else {
      this.uiView.step = 5;
    }
  }

  userIsReady() {
    this.setLoader();
    this.$state.go("jobs");
  }

  sendUserToSignIn(data, dataForLogin) {
    console.log("sendUserToSignin");
    this.$state.go("signin", {signindata: {data, dataForLogin}});
  }

  renderFacebook() {
    console.log("renderFacebook....");
    console.dir(FB);
  }

  checkFBLoginState() {
    console.log("checkFBLoginState");
  }

  fbSuccessfulLogin() {
    console.log("fbSuccessfulLogin");
    console.dir(FB);

    let data = {};
    let dataForLogin = {};

    var _this = this;

    FB.getLoginStatus(function (response) {
      console.log("getting facebook login status 2");
      console.dir(response);

      var fbResponse = response;

      if (response.status === "connected") {
        _this.setLoader();

        FB.api("/me?fields=name,email,first_name,last_name", function (response) {
          console.log("what is response from me");
          console.dir(response);
          _this.unSetLoader();
          if (!response.email) {
            _this.handleFaceBookNoEmail(response, fbResponse);
          } else {
            if (fbResponse.authResponse.accessToken) {
              dataForLogin.connectedAccountType = "FACEBOOK";
              dataForLogin.connectedAccountToken = fbResponse.authResponse.accessToken;
              data.username = response.email;
              data.firstName = response.first_name;
              data.lastName = response.last_name;
              data.connectedAccountType = "FACEBOOK";
              data.connectedAccountToken = fbResponse.authResponse.accessToken;
              _this.login(data, dataForLogin);
            }
          }
        });
      }
    });
  }

  handleFaceBookNoEmail(response, fbResponse) {
    console.log("handleFaceBookNoEmail");
  }

  renderApple() {
    this.$timeout(() => {
      AppleID.auth.init({
        clientId: this.$env.EnvironmentConfig.thirdPartySignon.apple,
        redirectURI: this.$env.EnvironmentConfig.thirdPartySignon.appleRedirectUrl,
        scope: "name email",
        usePopup: true, //or false defaults to false
      });
    }, 1000);
  }

  loadSignOnButtons(error) {
    console.log("loadSignOnButtons");

    this.setLoader();

    if (this.uiView.accountType.business === true) {
      this.renderGoogle();
    } else {
      this.renderGoogle();
      this.renderFacebook();
      this.renderApple();
    }

    if (error) {
      this.$timeout(() => {
        alert("Please select the correct login provider. " + error);
      }, 2000);
    }

    this.$timeout(() => {
      this.unSetLoader();
    }, 1300);
  }

  setLoader() {
    this.$timeout(() => {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    this.$timeout(() => {
      $("html").removeClass("wait");
    });
  }

  removeBodyClass() {
    this.$timeout(() => {
      $("body").removeClass();
    });
  }

  handleAppleSignin(response) {
    console.log("handleAppleSignin");
    console.dir(response);

    let data = {};
    let dataForLogin = {};

    if (response.user) {
      data.username = response.user.email;
      data.firstName = response.user.name.firstName;
      data.lastName = response.user.name.lastName;
      data.connectedAccountType = "APPLE";
      data.connectedAccountToken = response.authorization.id_token;
      dataForLogin.connectedAccountType = "APPLE";
      dataForLogin.connectedAccountToken = response.authorization.id_token;

      this.register(data, dataForLogin, "apple");
    } else {
      alert("No email was returned from apple");
    }
  }

  determineUserType() {
    let urlParam = this.$location.$$search.accountType;
    let actionParam = this.$location.$$search.action;

    console.log("what is the userparams");
    console.dir(urlParam);

    if (urlParam === "business") {
      this.uiView.accountType.jobbler = false;
      this.uiView.accountType.business = true;

      this.$timeout(() => {
        this.loadSignOnButtons();
      }, 300);
    } else if (urlParam === "jobbler") {
      this.uiView.accountType.jobbler = true;
      this.uiView.accountType.business = false;

      this.$timeout(() => {
        this.loadSignOnButtons();
      }, 300);
    } else {
      this.uiView.accountType.jobbler = true;
      this.uiView.accountType.business = false;

      this.$timeout(() => {
        this.loadSignOnButtons();
      }, 300);
    }

    console.log("look at state params here");
    console.dir(this.$stateParams);

    if (actionParam === "signin") {
      this.actionHeader = "Sign in";
    } else {
      this.actionHeader = "Sign up";
    }

    if (this.$stateParams.signindata) {
      this.displayVerificationMessage(this.$stateParams.signindata.signOnData.data.username);
    }
  }

  formChange(field, page) {
    this.errors = this.errors || {};
    console.log("formChange");
    console.dir(field);
    console.dir(page);
    this.$timeout(() => {
      this.errors = this.$profile.validateProfile(this.currentUser, field, this.errors);
    });
  }

  displayVerificationMessage(email) {
    this.verificationError =
      "A verification email was just sent to " +
      email +
      ". Please click the link in that email for verification and then attempt to your third party sign on again.";
    this.sendVerificationEmail(email);
  }

  sendVerificationEmail(email) {
    var _this = this;
    let user = {};

    user.email = email;

    _this.$profile.resendEmail(user).then(
      function (response) {
        console.log("resent email");
        console.dir(response);
      },
      function (error) {
        console.log("error resending email verification");
        console.dir(error);
      }
    );
  }

  confirmEmail(data, dataForLogin, needEmailConfirmation) {
    if (needEmailConfirmation === true) {
      this.payload.needEmailConfirmation = true;
      this.payload.data = data;
      this.payload.dataForLogin = dataForLogin;
    }

    this.$timeout(() => {
      this.uiView.step = 4;
      this.uiView.email = data.username;
    });
  }

  sendConfirmedEmail() {
    console.log("sendConfirmedEmail");
    console.dir(this.uiView.email);
    console.dir(this.payload);

    if (this.sendingConfirmaionEmail === true) {
      return;
    }

    this.sendingConfirmaionEmail = true;

    this.payload.data.username = this.uiView.email;

    let data = this.payload.data;
    let dataForLogin = this.payload.dataForLogin;

    this.register(data, dataForLogin, false);
  }

  setCompanyPage(data, dataForLogin, needEmailConfirmation) {
    this.payload.data = data;
    this.payload.dataForLogin = dataForLogin;
    this.payload.needEmailConfirmation = needEmailConfirmation;
    this.uiView.step = 0;
  }

  saveCompanyName() {
    console.log("saveCompanyName");
    console.dir(this.uiView);
    console.dir(this.payload);
    this.setLoader();

    let data = this.payload.data;
    let dataForLogin = this.payload.dataForLogin;

    data.company.name = this.uiView.companyName;
    data.company.mainContactInfo = {};
    data.company.mainContactInfo.phoneMobile = "2222222222";
    this.$timeout(() => {
      this.unSetLoader();
      this.confirmEmail(data, dataForLogin, true);
    }, 1000);
  }

  faceBookRendered() {
    var Cbuild1 = null;

    this.$timeout(() => {
      Cbuild1 = document.getElementById("fbloginbutton");
      Cbuild1.innerHTML =
        "<fb:login-button scope='email' onlogin='window.fbOnLogin()' data-width='328' data-size='large' data-button-type='continue_with' data-layout='default' data-auto-logout-link='false' data-use-continue-as='false'></fb:login-button>";
    }, 1500);

    this.$timeout(() => {
      FB.XFBML.parse();
    }, 2000);
  }

  smsCodeBackSpace(event, inputSequence) {
    if (event.keyCode === 8) {
      if (inputSequence !== 1) {
        let activeValue = $(".apply-profile-modal .modal-content .sms-code-container input#sms-code-" + inputSequence).val();
        if (activeValue === "") {
          this.$timeout(() => {
            $(".apply-profile-modal .modal-content .sms-code-container input#sms-code-" + (inputSequence - 1)).focus();
          });
        }
      }
    }
  }
}

SignonController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "$location",
  "$window",
  "signup.validator",
  "$stateParams",
  "profile",
  "auth",
  "env",
  "signon",
  "$timeout",
  "security",
  "$rootScope",
  "$scope",
  "tracking",
  "$cookies",
  "social",
  "validation",
];

export default SignonController;



// WEBPACK FOOTER //
// ./client/app/components/signon/signon.controller.js